import { useEffect } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { InfoBox } from "./InfoBox";
import { StatementDataBox } from "./statement/StatementDataBox";
import { BillDataBox } from "./bill/BillDataBox";
import { DetailActionTypeEnum, useDetailModel } from "./detailModel";

const DetailDataBox = () => {
    const { actionType } = useDetailModel();

    switch (actionType) {
        case DetailActionTypeEnum.STATEMENT:
            return <StatementDataBox />;
        case DetailActionTypeEnum.BILL:
            return <BillDataBox />;
        default:
            return <></>
    }
}

export const ContractDetail = () => {

    return (
        <>
            <YhPageHeader title="合约详情" />
            <InfoBox />
            <DetailDataBox />
        </>
    )
}